import { render, staticRenderFns } from "./InnerFrame.vue?vue&type=template&id=b3de15bc&scoped=true&"
import script from "./InnerFrame.vue?vue&type=script&lang=js&"
export * from "./InnerFrame.vue?vue&type=script&lang=js&"
import style0 from "./InnerFrame.vue?vue&type=style&index=0&id=b3de15bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3de15bc",
  null
  
)

export default component.exports